import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './UpdatesFeed.module.css';
import globalStyles from '../styles/global.module.css';
import apiConfig from '../config/api';
import UpdateCard from './UpdateCard';

const PostsFeed = ({ limit }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch(`${apiConfig.baseUrl}${apiConfig.endpoints.updates}`);
        const data = await response.json();
        console.log('Posts data:', data);
        
        if (data) {
          setPosts(data);
        }
      } catch (error) {
        console.error('Error fetching posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  // Get only the limited number of posts if limit is provided
  const displayedPosts = limit ? posts.slice(0, limit) : posts;

  return (
    <div className={globalStyles.card}>
      <h2 className={styles.sectionTitle}>Latest Posts</h2>
      
      {loading ? (
        <p>Loading posts...</p>
      ) : posts.length === 0 ? (
        <p>No posts yet.</p>
      ) : (
        <>
          <div className={styles.updatesFeed}>
            {displayedPosts.map((post) => (
              <UpdateCard 
                key={post._id} 
                post={post} 
                showDate={true}
                className={styles.updateCard}
              />
            ))}
          </div>
          
          {limit && posts.length > limit && (
            <div className={styles.viewAllLink}>
              <Link to="/posts" className={globalStyles.linkButton}>
                View All Posts ({posts.length})
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PostsFeed; 